module.exports = __webpack_public_path__ + "img/Body_DiffuseColor.108733e.png";